//Menu hover
let items = document.querySelectorAll(".header__inline-menu details");

items.forEach((item) => {
  let timer;

  item.addEventListener("mouseenter", () => {
    clearTimeout(timer);
    item.setAttribute("open", true);
  });

  item.addEventListener("mouseleave", () => {
    timer = setTimeout(() => {
      if (
        !item.matches(":hover") &&
        !item.querySelector("ul").matches(":hover")
      ) {
        item.removeAttribute("open");
      }
    }, 200);
  });

  let ul = item.querySelector("ul");
  if (ul) {
    ul.addEventListener("mouseenter", () => {
      clearTimeout(timer);
    });

    ul.addEventListener("mouseleave", () => {
      timer = setTimeout(() => {
        if (!item.matches(":hover")) {
          item.removeAttribute("open");
        }
      }, 200);
    });
  }
});
